export const addError = (error: Error) => {
	const RumGlobal = window.DD_RUM;
	if (RumGlobal) {
		RumGlobal.addError(error);
	}
};
